// Import Swiper and modules
import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Thumbs, EffectCreative } from 'swiper';

// Install modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs, EffectCreative]);

export function initSwiper() {
	const initSwiper = document.querySelectorAll('[data-swiper]');
	const newsSlider = document.querySelector('.latest-news__swiper');
	//console.log(initSwiper);
	
	if(initSwiper) {
		initSwiper.forEach((element) => {
			let params = JSON.parse(element.dataset.swiper);
			new Swiper(element, params);
		});
	}

}
